import { post_images_path } from '~/routes';
import _ from 'underscore';
import './index.sass';
import axios from "axios";
import 'magnific-popup/dist/jquery.magnific-popup.min'

export default () => {
  const $input = $('.js-input-length');

  $(window).on('load', () => {
    $input.trigger('input');
  })

  $('body').on('input', '.js-input-length', function() {
    $('.js-create-limit').text(60 - $(this).val().length);
    if($input.val().length > 4) {
      $('.js-form-submit').removeAttr('disabled')
    } else {
      $('.js-form-submit').attr('disabled', 'disabled')
    }
    return true;
  });

  $(function() {
    $('.js-post-image-upload').fileupload({
      url: post_images_path(),
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      dataType: 'json',
      formData: [],
      done: function(e, data) {
        var imageContainer;
        imageContainer = $('#image-container');
        imageContainer.addClass('loaded');
        imageContainer.find('.load-field').hide();
        imageContainer.find('.js-post-image-upload').hide();
        imageContainer.prepend("<div class='image-wrp'><a class='image-reset' /></a><img src='" + data.result.preview_url + "'/></div>");
        imageContainer.find('#post_image_cache').val(data.result.cache);
        imageContainer.find('#post_remove_image').val(0);
        $('input[name="post[image_cache]"]').val(data.result.cache);
        $('.cover-row').show();
        initCropper();
        return $('.cover-row img').attr('src', data.result.preview_url);
      },
      fail: function() {
        return showError(I18n.t('server_error'));
      }
    });

    $(document).on('click', '.js-form-submit', function(e){
      $('.js-posts-form').length && $('.js-posts-form').submit()
      if($(".js-job-form").length) {
        $('.js-form-submit').attr('disabled', true);

        e.preventDefault();

        CKEDITOR.instances.job_description.updateElement();

        const $form = $(".js-job-form");

        axios({
          method: 'POST',
          url: $form.attr('action'),
          data: $form.serialize(),
        }).then(response => {
          $form.trigger('reset');
          $.magnificPopup.open({
            items: {
              src: '#announcement-popup'
            },
            type: 'inline',
            closeBtnInside: true,
            callbacks: {
              afterClose: function() {
                window.location = '/'
              },
            }
          });

          $('.js-form-submit').attr('disabled', false);
        }).catch(err => {
          if (err.response.data.error.title.length) {
            const errorTitle = err.response.data.error.title[0].head;
            const errorText = err.response.data.error.title[0].text;
        
            $('.confirmation-modal-title').text(errorTitle);
            $('.confirmation-modal-text').text(errorText);
        
            $('.confirmation-modal').fadeIn(300);
            $('.confirmation-modal-content').fadeIn(300);
          } 
          $('.js-form-submit').attr('disabled', false);
        })
      }
    });

    $(document).on('click', '.confirmation-modal-close', function() {
      $('.confirmation-modal').fadeOut(300);
      $('.confirmation-modal-content').fadeOut(300);
    });

    $(document).on('click', '.image-reset', function(e) {
      var imageContainer;
      imageContainer = $('#image-container');
      imageContainer.removeClass('loaded');
      imageContainer.find('.load-field').show();
      imageContainer.find('.js-post-image-upload').show();
      imageContainer.find('.image-wrp').remove();
      imageContainer.find('#post_image_cache').val('');
      imageContainer.find('#post_remove_image').val(1);
      $('.cover-row').hide();
      $('.cover-row img').attr('src', '');
      $('.image-wrp img').attr('src', '');
    });
    $(document).on('click', '.button-flag', function(e, data) {
      var self;
      self = this;
      $('body').css('overflow', 'hidden');
      $('#modal-container').html($('#modal-spam').html());
      $('#modal-container').find('.js-button-ok').click(function() {
        return $.post($(self).attr('href'), function(data) {
          return $('.modal-close').trigger('click');
        });
      });
      return false;
    });
    const initCropper = function () {
      $(document).on('click', '.cover-choose', function(e) {
        var $el, $submitButton, cropper, currentZoom, gridY, onBuilt, src, zoomPanelHeight;
        e.preventDefault();
        $el = $('#modal-container').html(_.template($('#modal-post-cover').html()));
        $('body').css('overflow', 'hidden');
        $('.modal-wrp').fadeIn(400);
        src = $('.cover-row img').attr('src');
        $('.modal-wrp .image-wrp img').attr('src', src);
        zoomPanelHeight = $('a.moving-circle').parent().height() - $('a.moving-circle').height();
        gridY = parseInt(zoomPanelHeight / 10, 10);
        $submitButton = $('.js-form-submit');
        onBuilt = function() {
          $(this).cropper('reset');
          $(this).cropper('setDragMode', 'move');
          $(this).cropper('setData', {
            width: 330,
            height: 150
          });
          return $('.cropper-drag-box, .cropper-crop-box').on('mousewheel', function(e) {
            return e.stopPropagation();
          });
        };
        cropper = $('.modal-wrp .image-wrp img').cropper({
          rotatable: true,
          cropBoxMovable: true,
          cropBoxResizable: true,
          dragMode: 'move',
          preview: 'a.cover-preview',
          built: onBuilt
        });
        currentZoom = 0;
        $('a.moving-circle').draggable({
          axis: 'y',
          containment: 'parent',
          grid: [0, gridY],
          drag: (function(_this) {
            return function(event, ui) {
              var circleTop, newZoom;
              ui.position.top = Math.min(ui.position.top, 140);
              circleTop = parseInt($('a.moving-circle').css('top'), 10);
              newZoom = Number((1 - parseFloat(ui.position.top / zoomPanelHeight)).toFixed(1));
              if (circleTop === ui.position.top) {
                return;
              }
              cropper.cropper('zoom', newZoom - currentZoom);
              return currentZoom = newZoom;
            };
          })(this)
        });
        $submitButton.on('click', function(e) {
          var data;
          data = cropper.cropper('getData');
          $('input#post_crop_x').val(data.x);
          $('input#post_crop_y').val(data.y);
          $('input#post_crop_width').val(data.width);
          return $('input#post_crop_height').val(data.height);
        });
      });
    }
  });

}
